import { render, staticRenderFns } from "./attachmentScreenshot.vue?vue&type=template&id=f554ee7c&scoped=true&"
import script from "./attachmentScreenshot.vue?vue&type=script&lang=js&"
export * from "./attachmentScreenshot.vue?vue&type=script&lang=js&"
import style0 from "./attachmentScreenshot.vue?vue&type=style&index=0&id=f554ee7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f554ee7c",
  null
  
)

export default component.exports